import {
	Box,
	Container,
	HStack,
	SimpleGrid,
	Tab,
	TabList,
	TabPanel,
	TabPanels,
	Tabs,
	Text,
	VStack,
} from "@chakra-ui/react";
import React from "react";
import useGlobalStyles, { DEFAULT_IDS } from "../../hooks/useGlobalStyles";

export const StyleGuidePreview = () => {
	const { styles } = useGlobalStyles();

	React.useEffect(() => {
		wp.data.dispatch("core/block-editor").clearSelectedBlock();
	}, []);

	return (
		<Box
			position="absolute"
			top={0}
			left={0}
			w="full"
			h="full"
			zIndex={1}
			p="40px"
			bg="white"
		>
			<Tabs align="center">
				<TabList>
					<Tab>Color</Tab>
					<Tab>Text</Tab>
				</TabList>
				<TabPanels mt="16">
					<TabPanel>
						<Container maxW="600px">
							<HStack spacing="40px">
								<Box alignSelf="flex-start">
									<Text as="span">DEFAULT</Text>
								</Box>
								<SimpleGrid columns={2} w="full" spacing="8px">
									{styles.colors
										.filter((c) =>
											DEFAULT_IDS.includes(c.id)
										)
										.map((c) => (
											<Box
												key={c.id}
												textAlign="left"
												mb="8px"
											>
												<Box
													height="100px"
													bgColor={`var(--mzb-colors-${c.id})`}
												/>
												<Text as="span" mt="4px">
													{c.name}
												</Text>
											</Box>
										))}
								</SimpleGrid>
							</HStack>
							<HStack mt="60px" spacing="40px">
								<Box alignSelf="flex-start">
									<Text as="span">CUSTOM</Text>
								</Box>
								<SimpleGrid columns={2} w="full" spacing="8px">
									{styles.colors
										.filter(
											(c) => !DEFAULT_IDS.includes(c.id)
										)
										.map((c) => (
											<Box
												key={c.id}
												textAlign="left"
												mb="8px"
											>
												<Box
													height="100px"
													bgColor={`var(--mzb-colors-${c.id})`}
												/>
												<Text as="span" mt="4px">
													{c.name}
												</Text>
											</Box>
										))}
								</SimpleGrid>
							</HStack>
						</Container>
					</TabPanel>
					<TabPanel>
						<Container maxW="600px">
							<HStack spacing="40px">
								<Box alignSelf="flex-start">
									<Text as="span">DEFAULT</Text>
								</Box>
								<VStack spacing="8px" w="full">
									{styles.typographies
										.filter((c) =>
											DEFAULT_IDS.includes(c.id)
										)
										.map((c) => (
											<Box
												key={c.id}
												textAlign="left"
												border="1px"
												borderColor="gray.200"
												w="full"
												p="4"
												borderRadius="base"
												bg="gray.100"
											>
												<Text as="span" mt="4px">
													{c.name}
												</Text>
												<Text
													className={`mzb-typography-${c.id}`}
												>
													The quiz fox jumps over lazy
													dog.
												</Text>
											</Box>
										))}
								</VStack>
							</HStack>
							<HStack mt="60px" spacing="40px">
								<Box alignSelf="flex-start">
									<Text as="span">CUSTOM</Text>
								</Box>
								<VStack spacing="8px" w="full">
									{styles.typographies
										.filter(
											(c) => !DEFAULT_IDS.includes(c.id)
										)
										.map((c) => (
											<Box
												key={c.id}
												textAlign="left"
												border="1px"
												borderColor="gray.200"
												w="full"
												p="4"
												borderRadius="sm"
												bg="gray.100"
											>
												<Text as="span" mt="4px">
													{c.name}
												</Text>
												<Text
													className={`mzb-typography-${c.id}`}
												>
													The quiz fox jumps over lazy
													dog.
												</Text>
											</Box>
										))}
								</VStack>
							</HStack>
						</Container>
					</TabPanel>
				</TabPanels>
			</Tabs>
		</Box>
	);
};

export default StyleGuidePreview;
